import {ScrollTrigger} from "../LibrariesImport";
import {gsap} from "../LibrariesImport";
import DevHelpers from "../utils/DevHelpers";

export default class Halo {

    static init() {
        this.onScroll();
        this.onMousemove();
    }

    static onScroll() {
        const halosTop = document.querySelectorAll(".halo-scroll.halo-top");
        halosTop.forEach((el) => {
            gsap.to(el, {
                x: "200%",
                scrollTrigger: {
                    trigger: el,
                    start: 'top 95%',
                    end: 'bottom top',
                    scrub: true
                }
            });
        });


        const halosLeft = document.querySelectorAll(".halo-scroll.halo-left, .halo-scroll.halo-right");
        halosLeft.forEach((el) => {
            gsap.to(el, {
                y: "200%",
                scrollTrigger: {
                    trigger: el,
                    start: 'top 95%',
                    end: 'bottom top',
                    scrub: true
                }
            });
        });
    }

    static onMousemove() {
        const haloTop = document.querySelectorAll(".halo-mousemove.halo-top");
        haloTop.forEach((el) => {
            document.body.addEventListener('mousemove', function (e) {
                let vw = window.innerWidth;
                let xOffset = DevHelpers.clamp(((e.pageX / vw) * 50), 5, 100);
                el.style.left = xOffset + '%';
            });
        });

        const haloLeft = document.querySelectorAll(".halo-mousemove.halo-left, .halo-mousemove.halo-right");
        haloLeft.forEach((el) => {
            document.body.addEventListener('mousemove', function (e) {
                let vw = window.innerWidth;
                let yOffset = DevHelpers.clamp(((e.pageX / vw) * 50), 5, 100);
                el.style.top = yOffset + '%';
            });
        });
    }
}
